import { matchPath } from 'react-router-dom';
import { HORIZONTAL_MENU_ITEMS, MenuItemTypes } from '../../constants/menu';
import { isUserAdmin } from '../../services/locationService';
import { locationService } from '../../helpers/api/api.service';
import { Location } from '../../helpers/api/types';

export const transformMenuItems = (
  items: MenuItemTypes[],
  clientCode: string,
  locations: Location[] = []
): MenuItemTypes[] => {
  return items
    .filter(item => item.key !== 'clients' || isUserAdmin())
    .map(item => {
      const newItem: MenuItemTypes = { ...item };

      if (newItem.urlBasedOnClientCode && newItem.url) {
        newItem.url = `/${clientCode}${newItem.url}`;
      }

      if (newItem.children && newItem.children.length > 0) {
        newItem.children = transformMenuItems(newItem.children, clientCode, locations);
      }

      if (item.key === 'locations' && locations.length) {
        newItem.children = createLocationMenuItems(locations, clientCode);
        return newItem;
      }

      return item.key === 'locations' ? null : newItem;
    })
    .filter(Boolean) as MenuItemTypes[];
};

const createLocationMenuItems = (locations: Location[], clientCode: string): MenuItemTypes[] => {
  return locations.map(loc => ({
    key: loc.name,
    label: loc.name,
    isTitle: false,
    icon: loc.warning?.color,
    url: `/${clientCode}/location/${loc.id}`,
    parentKey: 'locations',
    urlBasedOnClientCode: false,
  }));
};

export const extractClientCodeFromPath = (pathname: string): string => {
  const pathMatch = matchPath<{ clientCode: string }>(pathname, {
    path: '/:clientCode/',
    exact: false,
    strict: false,
  });

  return pathMatch?.params.clientCode || '';
};

export const getHorizontalMenuItems = () => {
  // NOTE - You can fetch from server and return here as well
  //Deep clone array of objects!
  return JSON.parse(JSON.stringify(HORIZONTAL_MENU_ITEMS));
};

export const getLocationMap = async (clientId: string) => {
  try {
    let res = await locationService.getLocationsMap(clientId);
    if (res.status === 200) {
      if (res.data.length > 0) return res.data as Location[];
    }
    return [];
  } catch (err) {
    throw err;
  }
};

export const findMenuItem = (
  menuItems: MenuItemTypes[] | undefined,
  menuItemKey: MenuItemTypes['key'] | undefined
): MenuItemTypes | null => {
  if (menuItems && menuItemKey) {
    for (var i = 0; i < menuItems.length; i++) {
      if (menuItems[i].key === menuItemKey) {
        return menuItems[i];
      }
      var found = findMenuItem(menuItems[i].children, menuItemKey);
      if (found) return found;
    }
  }
  return null;
};

export const findAllParent = (menuItems: MenuItemTypes[], menuItem: MenuItemTypes): string[] => {
  let parents: string[] = [];
  const parent = findMenuItem(menuItems, menuItem['parentKey']);

  if (parent) {
    parents.push(parent['key']);
    if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
  }

  return parents;
};

export const findParentMenuItem = (menuItems: MenuItemTypes[], childKey: string): MenuItemTypes | null => {
  for (const item of menuItems) {
    if (item.children) {
      for (const child of item.children) {
        if (child.key === childKey) {
          return item;
        }

        if (child.children) {
          const found = child.children.find(c => c.key === childKey);
          if (found) return item;
        }
      }
    }
  }
  return null;
};

export const changeBodyAttribute = (attribute: string, value: string): void => {
  if (document.body) document.body.setAttribute(attribute, value);
};
